export default __webpack_public_path__ + "static/bgfinal-dabdc160f7460f54fc8c9446aa1bf5b3.jpg";